import React from 'react';
import { Search } from 'lucide-react';
import { TIPI, STATI } from './constants';

export const PraticheFilters = ({ search, setSearch, filterStato, setFilterStato, filterTipo, setFilterTipo, filterBeneficiario, setFilterBeneficiario, isAdmin }) => (
  <div className="flex gap-2 mb-4 flex-wrap">
    <div className="relative flex-1 min-w-[200px]">
      <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input type="text" placeholder="Cerca cliente, CF, compagnia..." value={search} onChange={e => setSearch(e.target.value)}
        className="w-full pl-9 pr-3 py-2 border border-slate-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-200" data-testid="search-pratiche" />
    </div>
    <select value={filterStato} onChange={e => setFilterStato(e.target.value)} className="px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white" data-testid="filter-stato">
      <option value="">Tutti gli stati</option>
      {STATI.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
    </select>
    <select value={filterTipo} onChange={e => setFilterTipo(e.target.value)} className="px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white" data-testid="filter-tipo">
      <option value="">Tutti i tipi</option>
      {TIPI.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
    </select>
    {isAdmin && (
      <select value={filterBeneficiario} onChange={e => setFilterBeneficiario(e.target.value)} className="px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white" data-testid="filter-beneficiario">
        <option value="">Tutte le provvigioni</option>
        <option value="agenzia">Solo Agenzia</option>
        <option value="collaboratore">Solo Collaboratore</option>
      </select>
    )}
  </div>
);
